import { render, staticRenderFns } from "./userComponent.vue?vue&type=template&id=334b5d21&scoped=true&"
import script from "./userComponent.vue?vue&type=script&lang=js&"
export * from "./userComponent.vue?vue&type=script&lang=js&"
import style0 from "./userComponent.vue?vue&type=style&index=0&id=334b5d21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334b5d21",
  null
  
)

export default component.exports